/** Pure auto-open policy. Refusal names are part of the Selection contract. */

export const AUTO_OPEN_ON_PHONE = false;

export const AUTO_OPEN_REFUSAL = Object.freeze({
  NO_PANEL: 'no-panel',
  KILL_SWITCH: 'kill-switch',
  PHONE: 'phone',
  PICK_MODE: 'pick-mode',
  MULTI_MODIFIER: 'multi-modifier',
  ELEMENT_MULTI: 'element-multi',
  TEXT_EDIT_INTENT: 'text-edit-intent',
  TEXT_EDIT_LIVE: 'text-edit-live',
  NO_ROOM: 'no-room'
});

export function glassAutoOpenEnabled(storage = globalThis.localStorage) {
  try {
    return storage?.getItem?.('pb-glass-autoopen') !== '0';
  } catch {
    return true;
  }
}

export function shouldAutoOpenPanel(payload, ctx = {}) {
  if (!payload || ctx.hasPanel === false)
    return { open: false, reason: AUTO_OPEN_REFUSAL.NO_PANEL };
  if (ctx.killSwitch === false) return { open: false, reason: AUTO_OPEN_REFUSAL.KILL_SWITCH };
  if (ctx.phone && !AUTO_OPEN_ON_PHONE) return { open: false, reason: AUTO_OPEN_REFUSAL.PHONE };
  if (ctx.pickMode) return { open: false, reason: AUTO_OPEN_REFUSAL.PICK_MODE };
  if (payload.metaKey || payload.ctrlKey || payload.shiftKey || ctx.multiModifier) {
    return { open: false, reason: AUTO_OPEN_REFUSAL.MULTI_MODIFIER };
  }
  if (ctx.elementMulti) return { open: false, reason: AUTO_OPEN_REFUSAL.ELEMENT_MULTI };
  if (payload.editIntent || ctx.textEditIntent) {
    return { open: false, reason: AUTO_OPEN_REFUSAL.TEXT_EDIT_INTENT };
  }
  if (ctx.textEditLive) return { open: false, reason: AUTO_OPEN_REFUSAL.TEXT_EDIT_LIVE };
  if (ctx.placementStrategy === 'none') {
    return { open: false, reason: AUTO_OPEN_REFUSAL.NO_ROOM };
  }
  return { open: true, reason: null };
}
